<template>
  <section :class="`popup ${showModal ? popupShowClass : ''}`" @click="showPostModal($event)">
    <div :class="`popup__container ${showModal ? popupContainerShowClass : ''}`">
      <button
      type="button"
      class="popup__button"
      title="Закрыть"
      @click="showPostModal($event)"
      ></button>
      <div class="popup__content">
        <div class="post-more-container">
          <modal-post :post="currentData"></modal-post>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// components
import ModalPost from '../../views/home/components/posts/ModalPost.vue';

// libraries
import moment from 'moment';

export default {
  name: 'ModalWindow',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    currentData: {
      type: Object,
    },
  },
  data() {
    return {
      popupShowClass: 'popup--show',
      popupContainerShowClass: 'popup__container--show',
      moment,
    };
  },
  methods: {
    showPostModal(event) {
      const target = event.target;
      this.$root.$emit('togglePostToModal', {target});
    },
    // перенести в helper при рефакторинге
    sourceIcon(source) {
      if (source === 'vk') return 'icon-vk.svg';
      if (source === 'fb') return 'icon-fb.svg';
      if (source === 'gs') return 'icon-smi.svg';
      if (source === 'tw') return 'icon-tw.svg';
      return 'icon-stab.png';
    },
  },
  components: {
    ModalPost,
  },
};
</script>

<style>
  @import "./css/style.css";
</style>
